import { render, staticRenderFns } from "./ShareStatsImage.vue?vue&type=template&id=3e477318&scoped=true&"
import script from "./ShareStatsImage.vue?vue&type=script&lang=js&"
export * from "./ShareStatsImage.vue?vue&type=script&lang=js&"
import style0 from "./ShareStatsImage.vue?vue&type=style&index=0&id=3e477318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e477318",
  null
  
)

export default component.exports